import { HttpMethods } from 'msw';

import { apiSlice } from '@/API/api.slice';
import { Endpoints } from '@/constants/api';
import Assignment, { AssignmentLiteDTO, AssignmentType, AssignmentTypeDTO } from '@/types/assignment.types';

export interface AssignmentFilter {
  departmentList?: number[];
  templateList?: number[];
}

export const assignmentsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignmentTypes: builder.query<AssignmentType[], void>({
      query: () => Endpoints.AssignmentsType,
      transformResponse: (response: AssignmentTypeDTO[]) => {
        return response.map((assignmentType) => ({
          atypeId: assignmentType.atype_id,
          name: assignmentType.name,
        }));
      },
    }),
    getAssignments: builder.query<Assignment[], AssignmentFilter>({
      query: (filter) => ({
        body: {
          DepartmentIds: filter.departmentList,
          TemplateIds: filter.templateList,
        },
        method: HttpMethods.POST,
        url: `${Endpoints.Assignments}`,
      }),
      transformResponse: (response: AssignmentLiteDTO[]) => {
        if (!response) return [];

        // Eat duplicate assignments NOM NOM NOM :cookie:
        const seenIds = new Set<number>();

        const result: Assignment[] = [];

        response.forEach((assignment) => {
          if (seenIds.has(assignment.id) || !assignment.structures.length) return;

          seenIds.add(assignment.id);

          result.push({
            aTypeId: assignment.type.id,
            compactName: assignment.compact_name,
            departmentId: assignment.department.id,
            displayName: assignment.display_name,
            id: assignment.id,
            name: assignment.display_name,
            structures: assignment.structures,
          });
        });

        return result;
      },
    }),
  }),
});

export const { useGetAssignmentTypesQuery, useGetAssignmentsQuery } = assignmentsApi;
